// Potvrzení úspěšných AJAX akcí (ajaxFeedback.js); chyby hlásí server Shoptetu.
export default {
  coupon: 'Slevový kupón byl uplatněn.',
  watchdog: 'Hlídání je nastavené. Dáme vám vědět e-mailem.',
};
